function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "color", "icon", "isRemovable", "onRemove", "removeAriaLabel", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import { useState } from "react";
import classnames from "classnames";
import styles from "./Tag.module.css";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import IconCross from "#library/assets/icons/jds_cross.svg";
var iconSize = {
  small: ICON_SIZES.SMALL,
  medium: ICON_SIZES.MEDIUM,
  large: ICON_SIZES.BIG
};
export var Tag = function Tag(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "default" : _ref$color,
    icon = _ref.icon,
    _ref$isRemovable = _ref.isRemovable,
    isRemovable = _ref$isRemovable === void 0 ? false : _ref$isRemovable,
    onRemove = _ref.onRemove,
    removeAriaLabel = _ref.removeAriaLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasBeenRemoved = _useState2[0],
    setHasBeenRemoved = _useState2[1];
  var title = typeof children === "string" ? children : undefined;
  var handleRemove = function handleRemove(event) {
    if (onRemove) {
      onRemove(event);
    }
    setHasBeenRemoved(true);
  };
  var tagClassNames = classnames(styles["jds-Tag"], styles["jds-Tag--".concat(color)], styles["jds-Tag--".concat(size)], _defineProperty(_defineProperty({}, styles["jds-Tag--removable"], isRemovable), styles["jds-Tag--withIcon"], !!icon), className);
  var iconClassNames = classnames(styles["jds-Tag__Icon"], styles["jds-Tag__Icon--".concat(color)]);
  if (hasBeenRemoved) return null;
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: tagClassNames,
    title: title
  }), icon && /*#__PURE__*/React.createElement(Icon, {
    className: iconClassNames,
    size: iconSize[size],
    xlinkHref: icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles["jds-Tag__Label"],
    "aria-hidden": true
  }, children), isRemovable && /*#__PURE__*/React.createElement("button", {
    "aria-label": removeAriaLabel || "close",
    className: styles["jds-Tag__RemoveButton"],
    onClick: handleRemove,
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize[size],
    xlinkHref: "#".concat(IconCross.id)
  })));
};